import { Formatter } from '@ribajs/core'
import { _legacy } from '../../gen-2/services/SbnLocaleService'

/**
 * Translation formatter that works similar to Liquid's `t` filter.
 * Provides localization of strings with variable replacement.
 *
 * @param key - The translation key to lookup (e.g. "products.product.quantity.decrease")
 * @param varName - Optional variable name to replace in the translation (e.g. "product")
 * @param varValue - Optional value to use for the variable (e.g. a product title)
 *
 * @example
 * // Basic usage:
 * "products.product.quantity.decrease" | t
 *
 * @example
 * // With variable replacement:
 * "products.product.quantity.decrease" | t "product" productTitle
 *
 * @returns The translated string with variables replaced
 */
export const translateFormatter: Formatter = {
  name: 't',
  read(key: string, varName?: string, varValue?: string) {
    // If variable name and value are provided, use them as placeholders
    const placeholders: Record<string, string> = {}
    if (varName && varValue) {
      placeholders[varName] = varValue
    }

    // Return the translation with the placeholders applied
    return _legacy(key, placeholders)
  },
}
